<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    new-item
    help="flight-general-edit-multiple"
    @escape="escape"
    @save="save"
  >
    <template v-slot:editform>
      <v-card
        color="blue lighten-5"
      >
        <edit-form
          :flight-info="edited_item"
          :private-record="true"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="search"
            @click="getPreflightsGlider"
          >
            {{ $t('search_pre_flights_from_glider') }}
            <v-icon
              dark
            >
              {{ '$search' }}
            </v-icon>
          </v-btn>
          <v-btn
            color="search"
            @click="getPreflightsOgn"
          >
            {{ $t('search_pre_flights_from_ogn') }}
            <v-icon
              dark
            >
              {{ '$search' }}
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-data-table
        :headers="computed_headers"
        :items="pre_flights"
      >
        <template #item.date="{item}">
          {{ item.date | dateFormat }}
        </template>

        <template #item.takeoff_time="{item}">
          {{ item.takeoff_time | timeFormat }} - {{ item.landing_time | timeFormat }}
        </template>

        <template #item.plane="{item}">
          {{ item.plane.reg_num }} - {{ item.plane.model }}
        </template>

        <template #item.general_time="{item}">
          {{ timediff(item.takeoff_time, item.landing_time) }} / {{ (item.landing_counter - item.takeoff_counter).toFixed(2) }}
        </template>

        <template #item.counter="{item}">
          {{ item.takeoff_counter }} - {{ item.landing_counter }}
        </template>
      </v-data-table>
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'
  import moment from 'moment/moment'
  import { format } from 'date-fns'

  export default {
    name: 'FlightGeneralMultipleEdit',
    components: {
      EditForm: () => import('@/layouts/default/edit/FlightGeneralMultiple'),
    },
    data: function () {
      return {
        icon: '$edit',
        title: 'flight_datas',
        edited_item: {},
        loading: false,
        prevRoute: '/flight/general',
        saved: false,
        pre_flights: [],
      }
    },
    computed: {
      profile: get('auth/profile'),
      headers () {
        return [
          {
            text: this.$t('fields.date'),
            align: 'start',
            sortable: true,
            value: 'date',
          },
          {
            text: this.$t('fields.time'),
            sortable: true,
            value: 'takeoff_time',
          },
          {
            hide_small: true,
            text: this.$t('fields.plane'),
            sortable: false,
            value: 'plane',
          },
          {
            text: this.$t('fields.general_time'),
            sortable: false,
            value: 'general_time',
          },
          {
            hide_small: true,
            text: this.$t('fields.counter'),
            sortable: false,
            value: 'counter',
          },
        ]
      },
      computed_headers () { return this.headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown) },
    },
    watch: {
      'edited_item.plane_id': {
        handler () {
          console.log(this.edited_item.plane_id)
          // this.getPreflights()
        },
      },
      'edited_item.takeoff_time': {
        handler () {
          // this.getPreflights()
        },
      },
      'edited_item.landing_time': {
        handler () {
          // this.getPreflights()
        },
      },
    },
    mounted () {
      this.fetch()
      console.log(this.$route)
    },
    methods: {
      getLastFlight: call('flightGeneral/getLastFlight'),
      insertMultiple: call('flightGeneral/insertMultiple'),
      getFlightsGroupOgn: call('plane/getFlightsGroupOgn'),
      getFlightsGroupGlider: call('plane/getFlightsGroupGlider'),
      async fetch () {
        this.loading = true
        await this.getLastFlight(
          { plane_id: this.$route.params.plane_id },
        ).then(response => {
          this.edited_item = {
            date: format(new Date(), 'yyyy-MM-dd'), // '2022-12-31',
            plane_id: response.plane_id,
            pic_id: this.profile.user_id,
            first_takeoff_counter: response.landing_counter,
            // landing_counter: parseInt(response.landing_counter) + 2,
            takeoff_airport_id: response.landing_airport_id,
            landing_airport_id: response.landing_airport_id,
            // takeoff_time: '09:57',
            // landing_time: '13:30',
            landing: 1,
            task_id: 'tsk_14', // Towing
            // validation_at: '',
          }
        })
      },
      async save () {
        this.loading = true
        await this.insertMultiple({ flights: this.pre_flights },
        ).then(response => {
          this.saved = true
          this.escape()
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      getPreflightsOgn () {
        this.getFlightsGroupOgn(this.edited_item).then(response => {
          this.pre_flights = response
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      getPreflightsGlider () {
        this.getFlightsGroupGlider(this.edited_item).then(response => {
          this.pre_flights = response
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      escape () {
        this.$router.push(this.prevRoute).catch(() => {})
      },
      timediff (landingTime, takeoffTime) {
        return moment.utc(moment(takeoffTime, 'HH:mm:ss').diff(moment(landingTime, 'HH:mm:ss'))).format('HH:mm')
      },
    },
  }
</script>
